import { connect } from 'react-redux';
import InsurancePickerWrapper from './InsurancePickerWrapper';
import { setInsuranceType } from '../../data/insurance-type';
import {
    chooseCarrier,
    choosePlan,
    registerCallbacks,
    chooseNonInsuranceOption,
    setDirectoryId,
} from '../../data/dropdown-state/dropdownStateActions';
import { fetchCarriersIfNeeded } from '../../data/carriers';
import { fetchPlansIfNeeded } from '../../data/plans';

export const mapDispatchToProps = {
    setInsuranceType,
    chooseCarrier,
    choosePlan,
    registerCallbacks,
    chooseNonInsuranceOption,
    fetchCarriersIfNeeded,
    fetchPlansIfNeeded,
    setDirectoryId,
};

export default connect(undefined, mapDispatchToProps)(InsurancePickerWrapper);
